<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 4 24 18"><path fill="currentColor" d="M15.273 18.728A6.728 6.728 0 1 1 22 11.999V12a6.735 6.735 0 0 1-6.727 6.728" opacity=".5" /><path fill="currentColor" d="M8.727 18.728A6.728 6.728 0 1 1 15.455 12a6.735 6.735 0 0 1-6.728 6.728" /></svg>
</template>
